import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
//redux
import { useSelector, useDispatch } from "react-redux"
import { getUserTickets } from "helpers/repository"
import {Filter} from "./Filter";
import TicketTable from "./TicketTable";

const Tickets = props => {
    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [from, setFrom] = useState("")
    const [to, setTo] = useState("")
    const [type, setType] = useState("all")
    const [item, setItem] = useState("")
    const [modalData, setModalsData] = useState([])
    const [loadingMessage, setLoadingMessage] = useState("1");

    useEffect(() => {
        setLoadingMessage("1");
        getUserTickets(props.userId, successCallback, error, from, to, type, "Sports")
    }, [props.userId])


    useEffect(() => {
        let modalDatas= props.modelData;
        if(modalDatas){
            setModalsData(modalDatas);
        }

    }, [props.modelData]);

    const call = () => {
        setLoadingMessage("1");
        getUserTickets(props.userId, successCallback, error, from, to, type, item)
    }

    const successCallback = res => {
        setData(res?.data?.tickets)
        setLoadingMessage("0");
    }
    const error = err => {
        console.log("error")
    }

    return (
        <React.Fragment>
            <Filter
                setFrom={setFrom}
                setTo={setTo}
                setType={setType}
                setItem={setItem}
                item={item}
                call={() => {
                    call()
                }}
            />

            <TicketTable
                data={data}
                type={type}
                item={item}
                modalData={modalData}
                call={() => {
                    call()
                }}
                callById={(id) => {
                    props.callById(id)
                }}
                callByJackpotId={(jackpotId,id) => {
                    props.callByJackpotId(jackpotId,id)
                }}
                loadingMessage={loadingMessage}
                setLoadingMessage={setLoadingMessage}
            />

        </React.Fragment>
    )
}

export default withRouter(Tickets)
